import { render, staticRenderFns } from "./ChartChromatogram.vue?vue&type=template&id=07f422ac&scoped=true&"
import script from "./ChartChromatogram.vue?vue&type=script&lang=js&"
export * from "./ChartChromatogram.vue?vue&type=script&lang=js&"
import style0 from "./ChartChromatogram.vue?vue&type=style&index=0&id=07f422ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f422ac",
  null
  
)

export default component.exports